import { tryCatch } from "@/lib/try-catch";
import { Ok, Err } from "ts-results";
import { API_BASE_URL } from "@/lib/constants";
import { Response } from "./types";
import { z } from "zod";

export const requestTempPresignedUrlsSchema = z.object({
    amount: z.number().min(1, {
        message: "Se requiere al menos una imagen",
    }).max(1000 * 10, {
        message: "Maximo 10,000 imagenes",
    }),
});

export type RequestTempPresignedUrlsRequest = z.infer<typeof requestTempPresignedUrlsSchema>;

export const requestTempPresignedUrlsResponse = z.object({
  url: z.string(),
  key: z.string(),
});

export type RequestTempPresignedUrlsResponse = z.infer<typeof requestTempPresignedUrlsResponse>;

export async function requestTempPresignedUrls(
  request: RequestTempPresignedUrlsRequest
): Promise<Response<RequestTempPresignedUrlsResponse[]>> {
  const responseResult = await tryCatch(
    fetch(`${API_BASE_URL}/api/v1/presigned-urls?amount=${request.amount}`, {
      method: "POST",
      credentials: "include",
    })
  );

  if (responseResult.err) {
    return Err({
      message: `Error al consultar el servidor: ${responseResult.val.message}`,
      devMessage: responseResult.val.message,
    });
  }

  const response = responseResult.val;

  if (!response.ok) {
    const errMessageResult = await tryCatch(response.json());
    return errMessageResult.err
      ? Err({
          message: `Error al unir los archivos: ${errMessageResult.val.message}`,
          devMessage: errMessageResult.val.message,
        })
      : Err(errMessageResult.val);
  }

  const dataResult = await tryCatch(response.json());

  if (dataResult.err) {
    return Err({
      message: `Error al leer la respuesta del servidor: ${dataResult.val.message}`,
      devMessage: dataResult.val.message,
    });
  }

  return Ok(dataResult.val);
}
